import { render } from "./EditInspectionReport.vue?vue&type=template&id=00888ff0&scoped=true&ts=true"
import script from "./EditInspectionReport.vue?vue&type=script&lang=ts"
export * from "./EditInspectionReport.vue?vue&type=script&lang=ts"

import "./EditInspectionReport.vue?vue&type=style&index=0&id=00888ff0&scoped=true&lang=css"
import "./EditInspectionReport.vue?vue&type=style&index=1&id=00888ff0&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00888ff0"]])

export default __exports__